import * as moment from 'moment-timezone'
import jwtDecode from 'jwt-decode'

const ToolPlugin = {
  install (Vue, options) {
    let tool = {
      getClosestNumberFromArray: function (targetNumber, targetArray) {
        let closestNumber = targetArray.reduce((prev, curr) => {
          return (Math.abs(+curr - +targetNumber) < Math.abs(+prev - +targetNumber) ? +curr : +prev)
        })
        return closestNumber
      },
      playTts: function (text) {
        if ('speechSynthesis' in window) {
          let msg = new SpeechSynthesisUtterance(text)
          let voiceName = 'Google US English'
          msg.voice = window['speechSynthesis'].getVoices().filter(voice => { return voice.name === voiceName })[0]
          window['speechSynthesis'].speak(msg)
        } else {
          console.warn('TTS is not supported')
        }
      },
      cancelTts: function (text) {
        if ('speechSynthesis' in window) {
          window['speechSynthesis'].cancel()
        } else {
          console.warn('TTS is not supported')
        }
      },
      copyTextToClipboard: function (text) {
        let textArea = document.createElement('textarea')
        textArea.style.position = 'fixed'
        textArea.style.top = 0
        textArea.style.left = 0
        textArea.style.width = '2em'
        textArea.style.height = '2em'
        textArea.style.padding = 0
        textArea.style.border = 'none'
        textArea.style.outline = 'none'
        textArea.style.boxShadow = 'none'
        textArea.style.background = 'transparent'
        textArea.style.opacity = 0
        textArea.value = text
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()
        try {
          document.execCommand('copy')
          alert('"' + text + '" is successfully copied to your clipboard.')
        } catch (err) {
          alert('Oops, unable to copy text')
          console.warn('Oops, unable to copy text')
          console.warn(err)
        }
        document.body.removeChild(textArea)
      },
      makePhoneCall: function (phoneNumber) {
        window.location.href = 'tel:' + phoneNumber
      },
      sendEmail: function (emailAddress) {
        window.location.href = 'mailto:' + emailAddress
      },
      openMap: function (lat, lng) {
        let url = 'http://maps.apple.com/?q=' + lat + ',' + lng
        this.openNewTab(url)
      },
      openNewTab: function (url) {
        let win = window.open(url, '_blank')
        if (win) {
          // Browser has allowed it to be opened
          win.focus()
        } else {
          // Browser has blocked it
          alert('Please allow popups for this website')
        }
      },
      decodeJwtToken: function (str) {
        return jwtDecode(str)
      },
      encodeToBase64: function (str) {
        return window.btoa(str)
      },
      decodeFromBase64: function (base64Str) {
        return window.atob(base64Str)
      },
      encodeToBase64Url: function (str) {
        let base64Str = this.encodeToBase64(str)
        var base64Url = base64Str.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '')
        return base64Url
      },
      decodeFromBase64Url: function (base64Url) {
        if (base64Url.length % 4 === 2) base64Url = base64Url + '=='
        if (base64Url.length % 4 === 3) base64Url = base64Url + '='
        let base64Str = base64Url.replace(/-/g, '+').replace(/_/g, '/')
        let str = this.decodeFromBase64(base64Str)
        return str
      },
      capitalizeFirstLetter: function (string) {
        string = string.toLowerCase()
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      getUtcOffset: function (timezone) {
        return moment().tz(timezone).utcOffset()
      },
      getTodayBeginTimestamp: function (timezoneOffset) {
        let now = new Date()
        let timestamp = now.getTime()
        if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000
        let localNow = new Date(timestamp)
        timestamp = Math.floor((new Date((new Date(localNow.setHours(0))).setMinutes(0))).setSeconds(0) / 1000) * 1000
        if (timezoneOffset !== undefined) timestamp -= (now.getTimezoneOffset() * 60 * 1000 + timezoneOffset * 60 * 1000)
        return timestamp
      },
      getNowTimestamp: function (timezoneOffset) {
        let now = new Date()
        let timestamp = now.getTime()
        if (timezoneOffset !== undefined) timestamp += timezoneOffset * 60 * 1000 + now.getTimezoneOffset() * 60 * 1000
        return timestamp
      },
      getLocalTimestamp: function (timestamp, timezoneOffset) {
        let now = new Date()
        if (timezoneOffset !== undefined) timestamp += parseInt(timezoneOffset * 60 * 1000) + parseInt(now.getTimezoneOffset() * 60 * 1000)
        return timestamp
      },
      setFormatLocalTimeFromTimstamp: function (timestamp) {
        let formatTime = moment(timestamp).format('h:mm:ss A MM/DD')
        return formatTime
      },
      hasAllKeys: function (obj, keys) {
        let result = false
        if (obj instanceof Object && keys instanceof Array) {
          let undefinedKeys = []
          keys.map(key => {
            if (obj[key] === undefined) undefinedKeys.push(key)
          })
          if (undefinedKeys.length === 0) result = true
          else {
            console.log('utils.hasAllKeys failed')
            console.log(undefinedKeys)
          }
        } else {
          console.log('utils.hasAllKeys failed')
        }
        return result
      },
      getTimeDiffFromNow: function (timestamp) {
        let now = new Date()
        let diff = Math.round((now.getTime() - timestamp) / 1000)
        let text = null
        let textDetail = null
        if (diff < 60) {
          text = '1m'
          textDetail = diff + 's'
        } else if (diff < 60 * 60) {
          text = Math.round(diff / 60) + 'm'
          textDetail = text
        } else if (diff < 60 * 60 * 24) {
          text = Math.round(diff / 60 / 60) + 'h'
          textDetail = text
        } else {
          text = Math.round(diff / 60 / 60 / 24) + 'd'
          textDetail = text
        }
        return {
          text: text,
          textDetail: textDetail,
          diffInSec: diff
        }
      },
      getFriendlyTimeFromSec: function (seconds) {
        let text = null
        if (seconds < 60) {
          text = '1m'
        } else if (seconds < 60 * 60) {
          text = Math.round(seconds / 60) + 'm'
        } else if (seconds < 60 * 60 * 24) {
          text = Math.round(seconds / 60 / 60) + 'h'
        } else {
          text = Math.round(seconds / 60 / 60 / 24) + 'd'
        }
        return text
      },
      methodLogger (moduleName, logMessage) {
        let re = /at\s[a-zA-Z0-9.]+/g
        let aRegexResult = new Error().stack.match(re)
        let callerName = (aRegexResult[1] || aRegexResult[2]).replace('at ', '').replace('VueComponent.', '')
        let moduleNameCss = 'background:#000000 ; padding: 0 1px; border-radius: 0;  color: #fff'
        let callerNameCss = 'background:#35495e ; padding: 0 1px; border-radius: 0;  color: #fff'
        let logMessageCss = 'background:#41b883 ; padding: 0 1px; border-radius: 0;  color: #fff'
        if (moduleName && logMessage) {
          console.log('%c ' + moduleName + ' %c ' + callerName + ' %c ' + logMessage + ' ', moduleNameCss, callerNameCss, logMessageCss)
        } else if (moduleName) {
          console.log('%c ' + moduleName + ' %c ' + callerName + ' ', moduleNameCss, callerNameCss)
        } else if (logMessage) {
          console.log('%c ' + callerName + ' %c ' + logMessage + ' ', callerNameCss, logMessageCss)
        }
      },
      isValidEmailAddress (email) {
        let regexp = new RegExp('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')
        if (regexp.test(email)) {
          return true
        } else {
          return false
        }
      },
      isValidMacAddress (macAddress) {
        let regexp = new RegExp('[0-9A-F]{12}')
        if (regexp.test(macAddress)) {
          return true
        } else {
          return false
        }
      },
      getQuery () {
        let query = {}
        let queryString = window.location.href.split('?')[1]
        if (queryString) {
          let queryList = queryString.split('&')
          if (queryList.length > 0) {
            for (let i = 0; i < queryList.length; i++) {
              let key = queryList[i].split('=')[0]
              let value = queryList[i].split('=')[1]
              query[key] = value
            }
          }
        }
        return query
      },
      convertCamelToNormal (str) {
        return str
        // insert a space before all caps
          .replace(/([A-Z])/g, ' $1')
        // uppercase the first character
          .replace(/^./, function (str) { return str.toUpperCase() })
      },
      getCodecFromMP4: async function (blob) {
        let enc = new TextDecoder('utf-8')
        let arrBuffer = await new Response(blob).arrayBuffer()
        let byteArray = new Int8Array(arrBuffer)
        let items1 = enc.decode(byteArray).trim().split('moov')
        if (items1.length < 2) return null
        let items2 = items1[1].split('stsd')
        if (items2.length < 2) return null
        let videoBlock0 = items2[1]
        if (videoBlock0.length < 16) return null
        let codec = videoBlock0.slice(12, 16)
        if (codec === 'avc1') codec = 'h264'
        return codec
      }
    }
    Vue.prototype.$tool = tool
    Vue.tool = tool
  }
}

export default ToolPlugin



// WEBPACK FOOTER //
// ./src/plugins/tool.js